import React, { useEffect, useRef, useState } from 'react';
import mapimage from '../../Assets/maps/mapimage.jpg';
import craneonmap from '../../Assets/crane/craneonmapTopView.png';
import { useWebSocket } from '../../context/WebSocketContext';

import polyline from '@mapbox/polyline';

const userId = localStorage.getItem("userId");

function findClosestIndex(coord, polylineCoords) {
  let minDist = Infinity;
  let closestIndex = -1;

  for (let i = 0; i < polylineCoords.length; i++) {
    const [lng, lat] = polylineCoords[i];
    const dist = Math.hypot(coord[0] - lng, coord[1] - lat);
    if (dist < minDist) {
      minDist = dist;
      closestIndex = i;
    }
  }

  return closestIndex;
}

function getDistance(coord1, coord2) {
  const [lng1, lat1] = coord1;
  const [lng2, lat2] = coord2;

  const R = 6371000; // Earth radius in meters
  const toRad = deg => (deg * Math.PI) / 180;

  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) * Math.sin(dLng / 2) ** 2;

  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}


const OLAMapsForDriverLocation = ({
  dropLongitude, dropLatitude, pickupLatitude, pickupLongitude, driverLatitude, driverLongitude, showFullHeight, fullHeightRequired, driverOnTheWayDestination, adjustWidth, allowDriverProceed,driverChangedOnSelection
}) => {
  const mapRef = useRef(null);
  const driverMarkerRef = useRef(null); // Ref for the driver marker
  const mapInstanceRef = useRef(null); // Store map instance globally
  const previousDriverLocationRef = useRef(null); // store previous location
  const animationIntervalRef = useRef(null);
  const fullRouteRef = useRef([]);
  const hasFetchedRouteRef = useRef(false);
  const locationIntervalRef = useRef(null);
  const userHasZoomedRef = useRef(false); // Track if user manually changed zoom
  const isFirstAnimationRef = useRef(true); // Track first animation for initial zoom
  const previousBearingRef = useRef(0); // ✅ Per-marker bearing tracking
  


  const [pickLat, setPickLat] = useState(null);
  const [pickLng, setPickLng] = useState(null);
  const [dropLat, setDropLat] = useState(null);
  const [dropLng, setDropLng] = useState(null);
  const [driverLat, setDriverLat] = useState(null);
  const [driverLng, setDriverLng] = useState(null);
  // console.log('driverlang', driverLat, driverLng)
  const [startDrawingRoute, setStartDrawingRoute] = useState(false);

  const [driverChanged, setDriverChanged] = useState(false);
  const [driverTowardsDestination, setDriverTowardsDestination] = useState(false);
  const [newUpdate, setNewUpdate] = useState(false);
  const [defaultLocation, setDefaultLocation] = useState([77.0679, 28.4354]); // [lng, lat]
  const prepareRoute = (coords) => coords;

    const { sendMessage } = useWebSocket();
    const userId = localStorage.getItem("userId");
    
  // Function to get current coordinates and send via WebSocket
  const getCurrentCoords = () => {
    if (navigator.geolocation) {
      console.log("**************************** Location: Fetching current position location...", navigator);
      navigator.geolocation.getCurrentPosition(position => {
        console.log("***************************** Location... ", position.coords.latitude, position.coords.longitude);
        setDriverLat(position.coords.latitude);
        setDriverLng(position.coords.longitude);
        
        // Send update-location-vendor message via WebSocket
        const locationData = {
          type: "update-location-vendor",
          userId: userId,
          location: {
            ltd: position.coords.latitude,
            lng: position.coords.longitude,
          },
        };
        sendMessage(locationData);
      });
    }
  };

  let animationId;
let simulationIndex = 0;
let routeCoords = []; // to be filled later

// Note: Map centering is now handled by the animation function
// This useEffect was causing jittery animation by conflicting with animateDriverFromTo
// useEffect(() => {
//   const map = mapInstanceRef.current;
//   if (!map || !driverLat || !driverLng) return;
//   const newCoord = [driverLng, driverLat];
//   map.easeTo({
//     center: newCoord,
//     duration: 1000,
//   });
// }, [driverLat, driverLng]);

function getBearing(start, end) {
  const [lng1, lat1] = start;
  const [lng2, lat2] = end;
  
  const dLon = (lng2 - lng1) * Math.PI / 180;
  const y = Math.sin(dLon) * Math.cos(lat2 * Math.PI / 180);
  const x = Math.cos(lat1 * Math.PI / 180) * Math.sin(lat2 * Math.PI / 180) -
            Math.sin(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) * Math.cos(dLon);
  
  let brng = Math.atan2(y, x) * 180 / Math.PI;
  brng = (brng + 360) % 360; // normalize
  
  // ✅ Apply extra rotation offset
  brng = (brng + 91) % 360;
  
  return brng;
}

function updateRoutePolylineOnMap(routeCoords) {
console.log('routeCoords', routeCoords)
  const map = mapInstanceRef.current;
  if (!map) {
    console.log('map on reference', map)
    return
  };
    console.log('map loaded now ')

            const routeData = {
          type: 'Feature',
          properties: {},
          geometry: {
            type: 'LineString',
            coordinates : routeCoords,
          },
        };
            if (map.getSource('route')) {
          map.getSource('route').setData(routeData);
        } else {
          map.addSource('route', {
            type: 'geojson',
            data: routeData,
          });

          map.addLayer({
            id: 'route',
            type: 'line',
            source: 'route',
            layout: {
              'line-join': 'round',
              'line-cap': 'round',
            },
            paint: {
              'line-color': '#33c1ff',
              'line-width': 4,
            },
          });
        }
   

}

async function createPolylineTemp(){
  const apiKey = process.env.REACT_APP_OLA_API_KEY;
  let urlPart = "";
  if (userId.startsWith("VED")) {
    urlPart = driverTowardsDestination ? `${driverLat},${driverLng}|${dropLat},${dropLng}` : `${driverLat},${driverLng}|${pickLat},${pickLng}`
  } else {
    urlPart = driverTowardsDestination
      ? `${driverLat},${driverLng}|${pickLat},${pickLng}|${dropLat},${dropLng}`
      : `${driverLat},${driverLng}|${pickLat},${pickLng}`
  }



      const url = `https://api.olamaps.io/routing/v1/routeOptimizer?locations=${urlPart}&api_key=${apiKey}`;
      // console.log("🌐 Fetching route from:", url);

      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({}),
      });


      const data = await response.json();
      const encodedPolyline = data?.routes?.[0]?.overview_polyline;
      if (!encodedPolyline) return;

      const decoded = polyline.decode(encodedPolyline);
      const coordinates = decoded.map(([lat, lng]) => [lng, lat]);

      updateRoutePolylineOnMap(coordinates);
}

function animateDetour(path, marker, onComplete, previousBearingRef) {
  let step = 0;
console.log("Animating detour with path:", path);
  function next() {
    if (step >= path.length - 1) {
      if (onComplete) onComplete();
      return;
    }

    const current = path[step];
    const nextPoint = path[step + 1];
    const duration = 300; // milliseconds per segment
    const bearing = getBearing(current, nextPoint);

    animateMarker(marker, current, nextPoint, duration, bearing, () => {
      step++;
      next();
    }, previousBearingRef);
  }

  next();
}

function animateMarker(marker, from, to, duration, bearing, onComplete, previousBearingRef) {
  const markerEl = marker.getElement();
  updateMarkerRotation(bearing, markerEl, previousBearingRef);

  const start = performance.now();

  function frame(time) {
    const progress = Math.min((time - start) / duration, 1);

    console.log("Animating marker from", from, "to", to, "at progress", progress);
    const lng = from[0] + (to[0] - from[0]) * progress;
    const lat = from[1] + (to[1] - from[1]) * progress;

    marker.setLngLat([lng, lat]);

    if (progress < 1) {
      requestAnimationFrame(frame);
    } else {
      if (onComplete) onComplete();
    }
  }

  requestAnimationFrame(frame);
}

function updateMarkerRotation(bearing, markerEl, previousBearingRef) {
  if (!markerEl || !previousBearingRef) return;
  const img = markerEl.querySelector('img');
  if (!img) return;

  const imageRotationOffset = 140; // adjust for your image facing direction
  const rotation = bearing + imageRotationOffset;
  const prevBearing = previousBearingRef.current;

  // ✅ Calculate shortest angle distance to avoid 0-360 wrapping
  let angleDiff = rotation - prevBearing;
  if (angleDiff > 180) angleDiff -= 360;
  if (angleDiff < -180) angleDiff += 360;
  const absDiff = Math.abs(angleDiff);

  // ✅ Ignore bearing changes < 3 degrees (GPS jitter threshold)
  if (absDiff < 3) return;

  // ✅ Handle U-turns: Smooth transition instead of flipping
  // For large angle changes (>90°), smooth interpolation prevents visual spinning
  const smoothFactor = absDiff > 90 ? 0.1 : 0.15; // More aggressive smoothing for U-turns
  const smoothedRotation = prevBearing + angleDiff * smoothFactor;

  img.style.transformOrigin = 'center center';
  // ✅ Always use positive rotation, NO scaleX flip
  img.style.transform = `rotate(${smoothedRotation}deg)`;

  previousBearingRef.current = smoothedRotation;
}

function animateDriverFromTo(oldCoord, newCoord, routeCoords, startIndex, endIndex, totalDurationMs = 59000, onComplete) {
  const map = mapInstanceRef.current;
  const marker = driverMarkerRef.current;
  
  // Set initial zoom only on first animation
  if (isFirstAnimationRef.current && map) {
    map.setZoom(14);
    isFirstAnimationRef.current = false;
    
    // Listen for user zoom interaction
    map.on('zoomstart', (e) => {
      // Check if zoom was initiated by user (not programmatic)
      if (e.originalEvent) {
        userHasZoomedRef.current = true;
      }
    });
  }

  if (
    !map || !marker ||
    !routeCoords || routeCoords.length === 0 ||
    startIndex < 0 || endIndex < 0 ||
    startIndex >= routeCoords.length || endIndex >= routeCoords.length
  ) {
    console.warn("Invalid polyline animation range");
    return;
  } 

  // ✅ Check if new location is effectively same
   const startCoord = routeCoords[startIndex];
   const endCoord = routeCoords[endIndex];
   console.log("Animating from", startCoord, "to", endCoord);
  if (isSameLocation(startCoord, endCoord)) {
  console.warn("Same location received. Simulating detour animation...");

  // Simulate a short circular detour before coming back to the same point
  const fakeOffset = 0.00005; // ~5-10 meters in degrees

  // Create a triangle or mini-loop path
  const detourPath = [
    startCoord,
    [startCoord[0] + fakeOffset, startCoord[1] + fakeOffset],
    [startCoord[0] - fakeOffset, startCoord[1] + fakeOffset],
    startCoord
  ];

  // animateDetour(detourPath, marker, () => {
  //   console.log("Detour animation done, waiting for new location...");
  //   if (onComplete) onComplete();
  // });

  return;
}


  const isForward = endIndex > startIndex;
  const segment = isForward
    ? routeCoords.slice(startIndex, endIndex + 1)
    : routeCoords.slice(endIndex, startIndex + 1).reverse();

  const distances = [];
  let totalDistance = 0;

  for (let i = 0; i < segment.length - 1; i++) {
    const d = getDistance(segment[i], segment[i + 1]);
    distances.push(d);
    totalDistance += d;
  }

  let currentStep = 0;
  // ✅ Removed: lastMapUpdateTime and mapUpdateInterval - map.easeTo() now called once per segment

  function interpolatePosition(start, end, t) {
    const lng = start[0] + (end[0] - start[0]) * t;
    const lat = start[1] + (end[1] - start[1]) * t;
    return [lng, lat];
  }

  function animateStep() {
    if (currentStep >= segment.length - 1) {
      if (onComplete) onComplete(endIndex);
      return;
    }

    const current = segment[currentStep];
    const next = segment[currentStep + 1];
    const segmentDistance = distances[currentStep];
    const markerEl = marker.getElement();
    const bearing = getBearing(current, next);
    updateMarkerRotation(bearing, markerEl, previousBearingRef);

    const duration = totalDurationMs * (segmentDistance / totalDistance);
    const startTime = performance.now();
    let mapUpdated = false; // ✅ Only update map once per segment

    function step(timestamp) {
      const elapsed = timestamp - startTime;
      const t = Math.min(elapsed / duration, 1);
      const interpolated = interpolatePosition(current, next, t);

      // Update marker position on every frame (this is fast)
      marker.setLngLat(interpolated);

      // ✅ Update map center ONLY ONCE per segment, not every frame
      if (!mapUpdated && map) {
        map.easeTo({
          center: interpolated,
          duration: duration,
          essential: true
        });
        mapUpdated = true;
      }

      if (t < 1) {
        requestAnimationFrame(step);
      } else {
        currentStep++;
        animateStep();
      }
    }

    requestAnimationFrame(step);
  }

  animateStep();
}

// ✅ Helper: Check if two coordinates are approximately the same
function isSameLocation(coord1, coord2, thresholdMeters = 5) {
  const distance = getDistance(coord1, coord2);
  return distance < thresholdMeters;
}

// ✅ Helper: Haversine distance in meters
function getDistance(coord1, coord2) {
  const [lng1, lat1] = coord1;
  const [lng2, lat2] = coord2;

  const R = 6371000; // Radius of Earth in meters
  const toRad = deg => deg * Math.PI / 180;

  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);
  const a =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
    Math.sin(dLng / 2) ** 2;

  return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
}

const fetchDeviationRoute = async (startCoord, midCoord, endCoord) => {
  try {
    const apiKey = process.env.REACT_APP_OLA_API_KEY;
    const url = `https://api.olamaps.io/routing/v1/routeOptimizer?locations=${startCoord[1]},${startCoord[0]}|${midCoord[1]},${midCoord[0]}|${endCoord[1]},${endCoord[0]}&api_key=${apiKey}`;

    const response = await fetch(url, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({})
    });

    const data = await response.json();
    const encodedPolyline = data?.routes?.[0]?.overview_polyline;
    if (!encodedPolyline) return null;

    const decoded = polyline.decode(encodedPolyline);
    return decoded.map(([lat, lng]) => [lng, lat]);
  } catch (err) {
    console.error("❌ Failed to fetch deviation route:", err);
    return null;
  }
};

  useEffect(() => {
    if (pickupLatitude) setPickLat(parseFloat(pickupLatitude));
    if (pickupLongitude) setPickLng(parseFloat(pickupLongitude));
    if (dropLatitude) setDropLat(parseFloat(dropLatitude));
    if (dropLongitude) setDropLng(parseFloat(dropLongitude));
    if (driverLatitude) setDriverLat(parseFloat(driverLatitude));
    if (driverLongitude) setDriverLng(parseFloat(driverLongitude));
    setNewUpdate(true);
    if(driverChangedOnSelection){
      setDriverChanged(true);
      setStartDrawingRoute(false);
      hasFetchedRouteRef.current = false;
      // fullRouteRef.current = []; // Clear old route when driver changes
    }

    console.log("pickupLatitude, pickupLongitude, dropLatitude, dropLongitude, driverLatitude, driverLongitude, driverOnTheWayDestination", 
      pickupLatitude, pickupLongitude, dropLatitude, dropLongitude, driverLatitude, driverLongitude, driverOnTheWayDestination)
    driverOnTheWayDestination == false ? setDriverTowardsDestination(false) : setDriverTowardsDestination(true)
  }, [pickupLatitude, pickupLongitude, dropLatitude, dropLongitude, driverLatitude, driverLongitude, driverOnTheWayDestination]);


useEffect(() => {
  const fetchRouteOnce = async () => {
    if (
      !pickLat || !pickLng ||
      !dropLat || !dropLng ||
      !driverLat || !driverLng ||
      !startDrawingRoute ||
      hasFetchedRouteRef.current
    ) return;

    try {
      const apiKey = process.env.REACT_APP_OLA_API_KEY;
      let urlPart = "";
      if (userId.startsWith("VED")) {
        urlPart = driverTowardsDestination ? `${driverLat},${driverLng}|${dropLat},${dropLng}` : `${driverLat},${driverLng}|${pickLat},${pickLng}`
      } else {
        urlPart = driverTowardsDestination
          ? `${driverLat},${driverLng}|${pickLat},${pickLng}|${dropLat},${dropLng}`
          : `${driverLat},${driverLng}|${pickLat},${pickLng}`
      }
      const url = `https://api.olamaps.io/routing/v1/routeOptimizer?locations=${urlPart}&api_key=${apiKey}`;

      console.log('Fetching route from:', url);

      const response = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({}),
      });
        previousDriverLocationRef.current = [driverLng, driverLat]; 

      const data = await response.json();
      console.log("Full route response:", data);
      const encodedPolyline = data?.routes?.[0]?.overview_polyline;
      if (!encodedPolyline) return;

      const decoded = polyline.decode(encodedPolyline);
      const coordinates = decoded.map(([lat, lng]) => [lng, lat]);

      fullRouteRef.current = coordinates;
      hasFetchedRouteRef.current = true;

      // Draw full route initially
      console.log('Drawing full route on map:', coordinates);
      updateRoutePolylineOnMap(coordinates);

      // Start location tracking interval (only once, using ref)
      // if (!locationIntervalRef.current) {
      //   locationIntervalRef.current = setInterval(getCurrentCoords, 5000);
      //   console.log('Location tracking interval started');
      // }

      console.log('Route fetched and drawn:', coordinates);
    } catch (err) {
      console.error("Failed to fetch route:", err);
    }
  };

  fetchRouteOnce();
}, [pickLat, pickLng, dropLat, dropLng, startDrawingRoute, driverTowardsDestination]);

// Cleanup interval only on unmount
useEffect(() => {
  return () => {
    if (locationIntervalRef.current) {
      clearInterval(locationIntervalRef.current);
      locationIntervalRef.current = null;
      console.log('Location tracking interval cleared on unmount');
    }
  };
}, []);


// Start/stop location tracking interval based on allowDriverProceed
useEffect(() => {
  if (allowDriverProceed === 1) {
    if (!locationIntervalRef.current) {
      locationIntervalRef.current = setInterval(getCurrentCoords, 5000);
      console.log('Location tracking interval started (allowDriverProceed = 1)');
    }
  } else {
    if (locationIntervalRef.current) {
      clearInterval(locationIntervalRef.current);
      locationIntervalRef.current = null;
      console.log('Location tracking interval stopped (allowDriverProceed != 1)');
    }
  }
}, [allowDriverProceed]);


useEffect(() => {
  console.log("..............................Driver location changed:", { driverLat, driverLng });
  if (!driverLat || !driverLng || fullRouteRef.current.length === 0 || allowDriverProceed === 0) return;

  const coordinates = fullRouteRef.current;
  const newCoord = [driverLng, driverLat];
  const oldCoord = previousDriverLocationRef.current;
  const destination = driverTowardsDestination ? [dropLng, dropLat] : [pickLng, pickLat]; // Z
  previousDriverLocationRef.current = newCoord;

  if (oldCoord) {
    const oldIndex = findClosestIndex(oldCoord, coordinates);
    const newIndex = findClosestIndex(newCoord, coordinates);

      // ✅ Check if both points are found AND moving in a valid direction
    const isForwardMovement = newIndex > oldIndex;
    const isBackwardMovement = newIndex < oldIndex;
    const isMovingAlongPath = isForwardMovement || isBackwardMovement;

    // ✅ Check proximity threshold (ensure driver is close enough to route)
    const oldProximity = getDistance(oldCoord, coordinates[oldIndex]);
    const newProximity = getDistance(newCoord, coordinates[newIndex]);
    const proximityThreshold = 100; // meters

    const isWithinProximity = oldProximity < proximityThreshold && newProximity < proximityThreshold;

    // ✅ Only consider on-path if moving along route AND within proximity
    const isOnPath = oldIndex !== -1 && newIndex !== -1 && isMovingAlongPath && isWithinProximity;

    
    if (isOnPath) {
      // Normal case: animate along existing route
      console.log("Driver on path, animating along route", {oldCoord, newCoord, oldIndex, newIndex, previousDriverLocationRef , coordinates});
      animateDriverFromTo(oldCoord, newCoord, coordinates, oldIndex, newIndex, 60000);
    } else {    
      console.warn("Driver deviated from route", { oldIndex, newIndex });

      // 🚗 Get new continuous route A → N → Z
      fetchDeviationRoute(oldCoord, newCoord, destination).then((newRouteCoords) => {
        if (!newRouteCoords) return;

        // Update polyline to show the new combined path
        console.log("-----------------------Fetched deviation route, updating polyline", newRouteCoords);
        fullRouteRef.current = newRouteCoords;
        updateRoutePolylineOnMap(newRouteCoords);

        // Animate from A → N using the start of new polyline
        const midIndex = findClosestIndex(newCoord, newRouteCoords);
        animateDriverFromTo(oldCoord, newCoord, newRouteCoords, 0, midIndex, 60000, () => {
          // Continue animating N → Z as new updates come in
          hasFetchedRouteRef.current = true; // prevent immediate refetch
        });
      });
    }
    

    // if (
    //   oldIndex !== -1 &&
    //   newIndex !== -1 
    //   // && newIndex !== oldIndex
    // ) {
    //   const isForward = newIndex > oldIndex;

    //   console.log("Animating from index", oldIndex, "to", newIndex);
    //   animateDriverFromTo(oldCoord, newCoord, oldIndex, newIndex, 60000, (finalIndex) => {
    //     const driverCurrentLatLng = coordinates[finalIndex];
    //     const remainingPath = coordinates.slice(finalIndex); // Remaining path from current
    //   });

    // } else {
    //   console.warn('Skipping animation due to invalid indices', { oldIndex, newIndex });
    // }
  } else {
    // Initial marker set
    driverMarkerRef.current?.setLngLat(newCoord);

    // ✅ At app start, show full route
    updateRoutePolylineOnMap(fullRouteRef.current);
  }

  previousDriverLocationRef.current = newCoord;
}, [driverLat, driverLng]);



  useEffect(() => {
    const loadMap = async () => {
      const { OlaMaps } = await import('olamaps-web-sdk');
      const apiKey = process.env.REACT_APP_OLA_API_KEY;
      const olaMaps = new OlaMaps({
        apiKey
      });

      console.log('setting map on default location', defaultLocation)

      const hasPickup = pickLng != null && pickLat != null && !isNaN(pickLng) && !isNaN(pickLat);
      const mapCenter = hasPickup ? [pickLng, pickLat] : defaultLocation;
      const myMap = olaMaps.init({
        style: 'https://api.olamaps.io/tiles/vector/v1/styles/default-light-standard/style.json',
        container: mapRef.current,
        center: mapCenter,
        zoom: 14,
      });

      const navigationControls = olaMaps.addNavigationControls({
        showCompass: true,
        showZoom: false,
        visualizePitch: false,
      });

      myMap.addControl(navigationControls);

      navigator.geolocation.getCurrentPosition(
        (pos) => {
          const userLng = pos.coords.longitude;
          const userLat = pos.coords.latitude;

          if (!pickLat || !pickLng) {
            // Only show current location marker if pickup/drop not set
            olaMaps
              .addMarker({ offset: [0, 6], anchor: 'bottom', color: 'green' })
              .setLngLat([userLng, userLat])
              .addTo(myMap);
            myMap.setCenter([userLng, userLat]);
          }
        },
        (err) => console.warn('Geolocation error:', err),
        { enableHighAccuracy: true }
      );

      // Add pickup marker
      if (pickLat && pickLng) {
        const pickupMarker = olaMaps
          .addMarker({ offset: [0, 6], anchor: 'bottom', color: 'black' })
          .setLngLat([pickLng, pickLat])
          .addTo(myMap);

        pickupMarker.on('dragend', () => {
          const { lng, lat } = pickupMarker.getLngLat();
          console.log('Updated pickup coords:', lat, lng);

          setPickLat(lat);
          setPickLng(lng);

          localStorage.setItem('pickLatitude', lat);
          localStorage.setItem('pickLongitude', lng);
        });

      }

      if (driverLat && driverLng) {
    const craneImg = document.createElement('div');
craneImg.style.width = '40px';
craneImg.style.height = '40px';
craneImg.style.display = 'flex';
craneImg.style.justifyContent = 'center';
craneImg.style.alignItems = 'center';
craneImg.style.transformOrigin = 'center center'; // ✅ entire wrapper

const img = document.createElement('img');
img.src = 'https://claimpro-dev.s3.ap-south-1.amazonaws.com/Assets/crane/craneonmap.png';
img.style.width = '100%';
img.style.height = '100%';
img.style.objectFit = 'contain';
img.style.transformOrigin = 'center center'; // ✅ critical for rotation
img.style.transition = 'transform 0.2s linear';

craneImg.appendChild(img);

const marker = olaMaps
  .addMarker({
    element: craneImg,
    anchor: 'center',  // ✅ ensure it centers correctly
    offset: [0, 0],    // ✅ no offset
  })
  .setLngLat([driverLng, driverLat])
  .addTo(myMap);

driverMarkerRef.current = marker;

      }

      if (dropLat && dropLng && driverTowardsDestination) {
        const dropMarker = olaMaps
          .addMarker({ offset: [0, 6], anchor: 'bottom', color: 'green' })
          .setLngLat([dropLng, dropLat])
          .addTo(myMap);

        dropMarker.on('dragend', () => {
          const { lng, lat } = dropMarker.getLngLat();
          console.log('Updated drop coords:', lat, lng);


          setDropLat(lat);
          setDropLng(lng);

          localStorage.setItem('dropLatitude', lat);
          localStorage.setItem('dropLongitude', lng);

        });
      }

      if (pickLat && pickLng && !dropLat && !dropLng) {
        myMap.setCenter([pickLng, pickLat]);
        myMap.setZoom(14);
      }

      // If both pickup and drop exist, draw the route
      if (pickLat && pickLng && dropLat && dropLng) {
        myMap.on('load', () => {
          mapInstanceRef.current = myMap;
          console.log('Map fully loaded');
          let lats = [];
          let lngs = [];
          if (userId.startsWith("VED")) {
            if (driverTowardsDestination) {
              lats = [driverLat, dropLat];
              lngs = [driverLng, dropLng];
            }
            else {
              lats = [pickLat, driverLat];
              lngs = [pickLng, driverLng];
            }
          } else {
            lats = [dropLat, pickLat, driverLat];
            lngs = [dropLng, pickLng, driverLng];
          }

          const minLat = Math.min(...lats);
          const maxLat = Math.max(...lats);
          const minLng = Math.min(...lngs);
          const maxLng = Math.max(...lngs);

          myMap.fitBounds(
            [[minLng, minLat], [maxLng, maxLat]],
            { padding: 20 }
          );
          setDriverChanged(false);
          setStartDrawingRoute(true); // This will trigger your drawOrUpdateRoute
          createPolylineTemp();

        });
        if (myMap.loaded()) {
          setStartDrawingRoute(true);

        }
      }
    };
    loadMap();
  }, [newUpdate, driverChanged]);

  return (
    <div
      id="map"
      ref={mapRef}
      style={{
        backgroundImage: `url(${mapimage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        width: adjustWidth ? '90vw' : '100vw',
        height: showFullHeight
          ? 'calc(100vh - 22em)'
          : fullHeightRequired
            ? '100vh'
            : '30vh'

      }}
    />
  );
};

export default OLAMapsForDriverLocation;




// import React, { useEffect, useRef, useState } from 'react';
// import mapimage from '../../Assets/maps/mapimage.jpg';
// import craneonmap from '../../Assets/crane/craneonmap.png';

// import polyline from '@mapbox/polyline';

// const OLAMapsForDriverLocation = ({
//   dropLongitude, dropLatitude, pickupLatitude, pickupLongitude, driverLatitude, driverLongitude, showFullHeight, fullHeightRequired, driverOnTheWayDestination,adjustWidth
// }) => {
//   console.log("Props received:", { pickupLatitude, pickupLongitude, dropLatitude, dropLongitude, showFullHeight, fullHeightRequired, driverLatitude, driverOnTheWayDestination: true , adjustWidth});
//   const mapRef = useRef(null);
//   const driverMarkerRef = useRef(null); // Ref for the driver marker
//   const mapInstanceRef = useRef(null); // Store map instance globally

//   const [pickLat, setPickLat] = useState(null);
//   const [pickLng, setPickLng] = useState(null);
//   const [dropLat, setDropLat] = useState(null);
//   const [dropLng, setDropLng] = useState(null);
//   const [driverLat, setDriverLat] = useState(null);
//   const [driverLng, setDriverLng] = useState(null);
//   const [startDrawingRoute, setStartDrawingRoute] = useState(false);

//   const [driverTowardsDestination, setDriverTowardsDestination] = useState(false);
//   const [newUpdate , setNewUpdate]=useState(false);
//   console.log('driver lat long only',driverLat,driverLng)

//   console.log('2353!driverTowardsDestination', pickLat, pickLng,dropLat,dropLng,driverTowardsDestination)

//   useEffect(() => {
//     console.log("Props here:", { pickupLatitude, pickupLongitude, dropLatitude, dropLongitude, showFullHeight, fullHeightRequired, driverLatitude, driverLongitude, });

//     if (pickupLatitude) setPickLat(parseFloat(pickupLatitude));
//     if (pickupLongitude) setPickLng(parseFloat(pickupLongitude));
//     if (dropLatitude) setDropLat(parseFloat(dropLatitude));
//     if (dropLongitude) setDropLng(parseFloat(dropLongitude));
//     if (driverLatitude) setDriverLat(parseFloat(driverLatitude));
//     if (driverLongitude) setDriverLng(parseFloat(driverLongitude));
//     console.log('2353!driverTowardsDestination1234', driverOnTheWayDestination)
//     setNewUpdate(true);

//     driverOnTheWayDestination == false ? setDriverTowardsDestination(false) : setDriverTowardsDestination(true)
//   }, [pickupLatitude, pickupLongitude, dropLatitude, dropLongitude, driverLatitude, driverLongitude, driverOnTheWayDestination]);




// useEffect(() => {
//   const drawOrUpdateRoute = async () => {
//     if (
//       driverLat == null || driverLng == null ||
//       pickLat == null || pickLng == null ||
//       dropLat == null || dropLng == null || startDrawingRoute == false
//     ) return;

//     console.log('start drawing rout', startDrawingRoute )
//     const apiKey = process.env.REACT_APP_OLA_API_KEY;
//     const urlPart = driverTowardsDestination
//       ? `${pickLat},${pickLng}|${dropLat},${dropLng}`
//       : `${driverLat},${driverLng}|${pickLat},${pickLng}`;
//     const url = `https://api.olamaps.io/routing/v1/routeOptimizer?locations=${urlPart}&api_key=${apiKey}`;

//     try {
//       const response = await fetch(url, {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({}),
//       });

//       const data = await response.json();
//       const encodedPolyline = data?.routes?.[0]?.overview_polyline;
//       if (!encodedPolyline) return;

//       const decoded = polyline.decode(encodedPolyline);
//       const coordinates = decoded.map(([lat, lng]) => [lng, lat]);

//       const routeData = {
//         type: 'Feature',
//         properties: {},
//         geometry: {
//           type: 'LineString',
//           coordinates,
//         },
//       };

//       const map = mapInstanceRef.current;
// if (!map) {
//   console.warn("Map is not initialized yet");
//   return;
// }
//       console.log('mappjalf', map)
//       if (map.getSource('route')) {
//         map.getSource('route').setData(routeData);
//       } else {
//         map.addSource('route', {
//           type: 'geojson',
//           data: routeData,
//         });

//         map.addLayer({
//           id: 'route',
//           type: 'line',
//           source: 'route',
//           layout: {
//             'line-join': 'round',
//             'line-cap': 'round',
//           },
//           paint: {
//             'line-color': '#33c1ff',
//             'line-width': 4,
//           },
//         });
//       }
//     } catch (err) {
//       console.error("Error drawing/updating route:", err);
//     }
//   };

//   drawOrUpdateRoute();

//   // Move marker if present
//   if (driverLat && driverLng && driverMarkerRef.current) {
//     driverMarkerRef.current.setLngLat([driverLng, driverLat]);
//   }

// }, [
//   driverLat,
//   driverLng,
//   pickLat,
//   pickLng,
//   dropLat,
//   dropLng,
//   driverTowardsDestination,
//   startDrawingRoute
// ]);



//   const [defaultLocation, setDefaultLocation] = useState([77.0679, 28.4354]); // [lng, lat]
//   console.log("pickLng, pickLat,dropLng, dropLat", pickLng, pickLat, dropLng, dropLat)

//   useEffect(() => {
//     console.log('pickLng, pickLat, dropLng, dropLng', pickLng, pickLat, dropLng, dropLng)
//     const loadMap = async () => {
//       const { OlaMaps } = await import('olamaps-web-sdk');
//       const apiKey = process.env.REACT_APP_OLA_API_KEY;
//       const olaMaps = new OlaMaps({
//         apiKey
//       });


//       console.log('setting map on default location', defaultLocation)
//       const hasPickup = pickLng != null && pickLat != null && !isNaN(pickLng) && !isNaN(pickLat);
//       const mapCenter = hasPickup ? [pickLng, pickLat] : defaultLocation;

//       // if (mapRef.current) {
//       //   mapRef.current.remove();
//       //   mapRef.current = null;
//       // }
//       const myMap = olaMaps.init({
//         style: 'https://api.olamaps.io/tiles/vector/v1/styles/default-light-standard/style.json',
//         container: mapRef.current,
//         center: mapCenter,
//         zoom: 15,
//       });

//       const navigationControls = olaMaps.addNavigationControls({
//         showCompass: true,
//         showZoom: false,
//         visualizePitch: false,
//       });

//       myMap.addControl(navigationControls);

//       // Try to get user's current location
//       navigator.geolocation.getCurrentPosition(
//         (pos) => {
//           const userLng = pos.coords.longitude;
//           const userLat = pos.coords.latitude;

//           if (!pickLat || !pickLng) {
//             // Only show current location marker if pickup/drop not set
//             olaMaps
//               .addMarker({ offset: [0, 6], anchor: 'bottom', color: 'green' })
//               .setLngLat([userLng, userLat])
//               .addTo(myMap);
//             myMap.setCenter([userLng, userLat]);
//           }
//         },
//         (err) => console.warn('Geolocation error:', err),
//         { enableHighAccuracy: true }
//       );






//       // Add pickup marker
//       if (pickLat && pickLng) {
//         const pickupMarker = olaMaps
//           .addMarker({ offset: [0, 6], anchor: 'bottom', color: 'black' })
//           .setLngLat([pickLng, pickLat])
//           .addTo(myMap);

//         pickupMarker.on('dragend', () => {
//           const { lng, lat } = pickupMarker.getLngLat();
//           console.log('Updated pickup coords:', lat, lng);

//           setPickLat(lat);
//           setPickLng(lng);

//           localStorage.setItem('pickLatitude', lat);
//           localStorage.setItem('pickLongitude', lng);
//         });

//       }

//       if (driverLat && driverLng) {
//         const craneImg = document.createElement('img');
//         craneImg.src = craneonmap;
//         craneImg.style.width = '40px';
//         craneImg.style.height = '40px';
//         craneImg.style.objectFit = 'contain';

//         const marker = olaMaps
//           .addMarker({
//             element: craneImg,
//             anchor: 'bottom',
//             offset: [0, 6],
//           })
//           .setLngLat([driverLng, driverLat])
//           .addTo(myMap);

//         driverMarkerRef.current = marker;
//       }

//       if (pickLat && pickLng) {
//         const pickupMarker = olaMaps
//           .addMarker({ offset: [0, 6], anchor: 'bottom', color: 'blue' })
//           .setLngLat([pickLng, pickLat])
//           .addTo(myMap);

//         pickupMarker.on('dragend', () => {
//           const { lng, lat } = pickupMarker.getLngLat();
//           console.log('Updated pickup coords:', lat, lng);

//           setPickLat(lat);
//           setPickLng(lng);

//           localStorage.setItem('pickLatitude', lat);
//           localStorage.setItem('pickLongitude', lng);
//         });

//       }


//       // Add drop marker
//       if (dropLat && dropLng && driverTowardsDestination) {
//         const dropMarker = olaMaps
//           .addMarker({ offset: [0, 6], anchor: 'bottom', color: 'green' })
//           .setLngLat([dropLng, dropLat])
//           .addTo(myMap);

//         dropMarker.on('dragend', () => {
//           const { lng, lat } = dropMarker.getLngLat();
//           console.log('Updated drop coords:', lat, lng);


//           setDropLat(lat);
//           setDropLng(lng);

//           localStorage.setItem('dropLatitude', lat);
//           localStorage.setItem('dropLongitude', lng);

//         });
//       }


//       console.log('drivelat', driverLat, driverLng, pickLat, pickLng , driverTowardsDestination)
//       // if (
//       //   driverLat != null && driverLng != null &&
//       //   pickLat != null && pickLng != null &&
//       //   !driverTowardsDestination &&
//       //   !isNaN(driverLat) && !isNaN(driverLng) &&
//       //   !isNaN(pickLat) && !isNaN(pickLng)
//       // ) {
//       //   myMap.fitBounds(
//       //     [[driverLng, driverLat], [pickLng, pickLat]],
//       //     { padding: 80 }
//       //   );
//       // }
      
//       // If either marker exists, fit the view
//       if (driverLat && driverLng && pickLat && pickLng && !driverTowardsDestination) {
//         console.log("driverLat && driverLng && pickLat && pickLng && !driverTowardsDestination", driverLat, driverLng, pickLat, pickLng, !driverTowardsDestination)
//         // myMap.fitBounds([[driverLng, driverLat], [pickLng, pickLat]], { padding: 80 });
//         myMap.fitBounds([[driverLng, driverLat], [pickLng, pickLat]], { padding: 80 });

//       } else if (pickLat && pickLng && dropLat && dropLng && driverTowardsDestination) {
//         myMap.fitBounds([[pickLng, pickLat], [dropLng, dropLat]], { padding: 80 });
//       } else if (pickLat && pickLng) {
//         myMap.setCenter([pickLng, pickLat]);

//         myMap.setPitch(0);
//         myMap.setBearing(0);
//         [13, 14, 15, 16, 17, 18].forEach(z => {
//           setTimeout(() => myMap.setZoom(z), 100 * z);
//         });

//         console.log('actual zoom level:', myMap.getZoom());


//       } else if (dropLat && dropLng) {
//         myMap.setCenter([dropLng, dropLat]);
//         myMap.setPitch(0);
//         myMap.setBearing(0);
//         [13, 14, 15, 16, 17, 18].forEach(z => {
//           setTimeout(() => myMap.setZoom(z), 100 * z);
//         });

//       }
//       else {
//         navigator.geolocation.getCurrentPosition((position) => {
//           const userLng = position.coords.longitude;
//           const userLat = position.coords.latitude;
//           myMap.setCenter([userLng, userLat]);
//           myMap.setPitch(0);
//           myMap.setBearing(0);
//           myMap.setZoom(18);

//           setDefaultLocation([userLng, userLat]);

//           olaMaps
//             .addMarker({ offset: [0, 6], anchor: 'bottom', color: 'green' })
//             .setLngLat([userLng, userLat])
//             .addTo(myMap);
//         });
//       }




//       if (pickLat && pickLng && !dropLat && !dropLng) {
//         myMap.setCenter([pickLng, pickLat]);
//         myMap.setZoom(15);
//       }


//       // If both pickup and drop exist, draw the route
//       if (pickLat && pickLng && dropLat && dropLng) {
//         const swLat = Math.min(pickLat, dropLat);
//         const swLng = Math.min(pickLng, dropLng);
//         const neLat = Math.max(pickLat, dropLat);
//         const neLng = Math.max(pickLng, dropLng);

//         // myMap.fitBounds(
//         //   [[swLng, swLat], [neLng, neLat]],
//         //   { padding: 80, duration: 1000 }
//         // );
//         const getRouteData = async () => {
//           try {
//             const urlPart = driverTowardsDestination
//               ? `${pickLat},${pickLng}|${dropLat},${dropLng}`     // Show pickup ➝ drop
//               : `${driverLat},${driverLng}|${pickLat},${pickLng}` // Show driver ➝ pickup

//             const url = `https://api.olamaps.io/routing/v1/routeOptimizer?locations=${urlPart}&api_key=${apiKey}`

//             const response = await fetch(url, {
//               method: 'POST',
//               headers: { 'Content-Type': 'application/json' },
//               body: JSON.stringify({}),
//             });

//             const data = await response.json();
//             return data;
//           } catch (err) {
//             console.error("Error fetching route data:", err);
//           }
//         };

//         const drawRoute = async () => {
//           const routeData = await getRouteData();
//           if (!routeData?.routes?.[0]) return;

//           const encodedPolyline = routeData.routes[0].overview_polyline;
//           const decoded = polyline.decode(encodedPolyline);
//           const coordinates = decoded.map(([lat, lng]) => [lng, lat]);

//           if (myMap.getSource('route')) myMap.removeSource('route');
//           if (myMap.getLayer('route')) myMap.removeLayer('route');

//           myMap.addSource('route', {
//             type: 'geojson',
//             data: {
//               type: 'Feature',
//               properties: {},
//               geometry: {
//                 type: 'LineString',
//                 coordinates,
//               },
//             },
//           });

//           myMap.addLayer({
//             id: 'route',
//             type: 'line',
//             source: 'route',
//             layout: {
//               'line-join': 'round',
//               'line-cap': 'round',
//             },
//             paint: {
//               'line-color': '#33c1ff',
//               'line-width': 4,
//             },
//           });
//         };

//           myMap.on('load', () => {
            
//             mapInstanceRef.current = myMap;
//             console.log('Map fully loaded');

//   setStartDrawingRoute(true); // This will trigger your drawOrUpdateRoute

//   // Optional: draw initial route here directly if needed
// });
//         // myMap.on('load', drawRoute);
//         if (myMap.loaded()) {
//           // drawRoute();
//           setStartDrawingRoute(true)
//         }
//       }
//     };

//     console.log('drivertowards destintat', driverOnTheWayDestination)
//     loadMap();
//   }, [newUpdate]);

//   return (
//     <div
//       id="map"
//       ref={mapRef}
//       style={{
//         backgroundImage: `url(${mapimage})`,
//         backgroundSize: 'cover',
//         backgroundPosition: 'center',
//         width: adjustWidth?'90vw':'100vw',
//         height: showFullHeight
//           ? 'calc(100vh - 22em)'
//           : fullHeightRequired
//             ? '100vh'
//             : '30vh'

//       }}
//     />
//   );
// };

// export default OLAMapsForDriverLocation;